import * as React from "react";
import '../styles/components/_verticalchunk.scss';

const VerticalChunk = ({children}) => (
	<div className="VerticalChunk">
		{children}
	</div>
);

export default VerticalChunk;